import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";

const TIDYCAL = "https://tidycal.com/book-a-meeting-with-schalk-coetzee";

export default function CTAButtons({ className = "", inquiryLabel = "Send General Inquiry", scheduleLabel = "Schedule Virtual Meeting", primaryTo = "/contact", testIdPrefix = "cta" }) {
    return (
        <div className={`flex flex-col sm:flex-row items-stretch sm:items-center gap-3 ${className}`}>
            <Link
                to={primaryTo}
                data-testid={`${testIdPrefix}-inquiry-btn`}
                className="btn-primary group"
            >
                {inquiryLabel}
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
            </Link>
            <a
                href={TIDYCAL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${testIdPrefix}-schedule-btn`}
                className="btn-secondary group"
            >
                <Calendar className="w-4 h-4" />
                {scheduleLabel}
            </a>
        </div>
    );
}

export { TIDYCAL };
